import { render, staticRenderFns } from "./EventCardDesktop.vue?vue&type=template&id=ec769042"
import script from "./EventCardDesktop.vue?vue&type=script&lang=js"
export * from "./EventCardDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports